import { render, staticRenderFns } from "./WidgetProductReviewsListV3Pc.vue?vue&type=template&id=674f1268"
import script from "./WidgetProductReviewsListV3Pc.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsListV3Pc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports